@if (loading) {
  <div>
    <img alt="Loader" src="/assets/img/loading.gif" [ngStyle]="{height: height}">
  </div>
}
